import { Slider, Modal } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SoilSearchProperties from '@/components/SoilSearchProperties';
import { RootState } from '@/redux';
import { updateFirstTabValues, updatePropertyList, updateSearchRadiusSetting } from '@/redux/reducer/soilSerach';
import { SoilProfileWarningAlertIcon, SoilSearchClearIcon } from '@/resource/IconComponentSets';
import { GetPropertyList, soilSearchGetRadiusSetting } from '@/util/Request';
import { GetPropertyListResponseModel, ISoilProfilePlaceGeoNames } from '@/util/Request/requestType';
import SoilInputSelectComponent from '@/components/SoilInputSelectComponent';
import './index.less';

const { confirm } = Modal;

interface IProps {
    excuteButtonClick?: () => void
    propertiesDivClick?: () => void
    saveQueryButtonClick?: () => void
}

const FirstTabComponent = (props: IProps) => {
    const {
        excuteButtonClick,
        propertiesDivClick,
        saveQueryButtonClick
    } = props;

    const {
        selectedPropertySet,
        currentRadius,
        placeSelectSet
    } = useSelector((state: RootState) => state.soilSearchPageData);

    const [selectedProperty, setSelectedProperty] = useState<GetPropertyListResponseModel>();

    const dispatch = useDispatch();

    const {
        radiusSetting,
        soilPropertyList,
    } = useSelector((state: RootState) => state.soilSearchPageData);

    const handlePropertyListSelect = (record: GetPropertyListResponseModel) => {
        setSelectedProperty(record);
        let haveAdded = false;
        let chemicalAllTagAdded = false;
        let physicalAllTagAdded = false;
        selectedPropertySet.forEach((item) => {
            if (record.id === item.id) {
                haveAdded = true;
            }
            if (item.id === -10) {
                chemicalAllTagAdded = true;
            }
            if (item.id === -20) {
                physicalAllTagAdded = true;
            }
        });

        // duplicated selected item filter
        if (haveAdded) {
            return;
        }

        if ((record.category === 'Physical' && physicalAllTagAdded) || (record.category === 'Chemical' && chemicalAllTagAdded)) {
            return;
        }

        // normal selected handle method
        if (record.id === -10) {
            const newSelectedPropertySet = selectedPropertySet.filter((item) => item.category !== 'Chemical' || item.id === -20);
            dispatch(updateFirstTabValues({selectedPropertySet: [record, ...newSelectedPropertySet]}));
            return;
        }

        if (record.id === -20) {
            const newSelectedPropertySet = selectedPropertySet.filter((item) => item.category !== 'Physical' || item.id === -10);
            dispatch(updateFirstTabValues({selectedPropertySet: [record, ...newSelectedPropertySet]}));
            return;
        }

        const cachePropertySelectedList = [...selectedPropertySet];
        cachePropertySelectedList.push(record);
        dispatch(updateFirstTabValues({selectedPropertySet: cachePropertySelectedList}));
    };

    // SECTION: useEffect are
    useEffect(() => {
        requestForRadiusSeting();
        requestForSoilProperties();
    }, []);

    const requestForRadiusSeting = useCallback(async () => {
        try {
            const res = await soilSearchGetRadiusSetting();
            dispatch(updateSearchRadiusSetting(res));
        } catch (err) {
            console.log(err);
        }
    }, []);

    const requestForSoilProperties = useCallback(async () => {
        try {
            const res = await GetPropertyList();
            dispatch(updatePropertyList([...res]));
        } catch(err) {
            console.log(err);
        }
    }, []);

    const handleDeleteItemTag = (index) => {
        const cachePlaceSet = [...placeSelectSet];
        dispatch(updateFirstTabValues({
            placeSelectSet: cachePlaceSet
        }));
    };

    const handleRemoveProperty = (removeItem: GetPropertyListResponseModel) => {
        const removedProperty = [];
        selectedPropertySet.forEach((item: GetPropertyListResponseModel) => {
            if (item.id !== removeItem.id) {
                removedProperty.push(item);
            }
        });
        dispatch(updateFirstTabValues({selectedPropertySet: removedProperty}));
    };

    const propertymWarning = () => {
        return confirm({
            className: 'soil-profile-warning-div',
            okButtonProps: { style: { borderRadius: '16px', width: '80px' }},
            title: '',
            icon: (
                <div style={{height: '50px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <SoilProfileWarningAlertIcon />
                    <span style={{
                        color: '#14151C',
                        fontSize: '16px',
                        fontFamily: 'Noto-Sans-Semibold',
                        fontWeight: 600,
                        marginLeft: '17px'
                    }}>
                        Warning
                    </span>
                </div>),
            content: 'Must select at least a property?',
            okText: 'OK',
            onCancel: () => {
                console.log('Cancel');
            },
            onOk: () => {
                console.log('click ok button');
            }
        });
    };

    const placemWarning = () => {
        return confirm({
            className: 'soil-profile-warning-div',
            okButtonProps: { style: { borderRadius: '16px', width: '80px' }},
            title: '',
            icon: (
                <div style={{height: '50px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <SoilProfileWarningAlertIcon />
                    <span style={{
                        color: '#14151C',
                        fontSize: '16px',
                        fontFamily: 'Noto-Sans-Semibold',
                        fontWeight: 600,
                        marginLeft: '17px'
                    }}>
                        Warning
                    </span>
                </div>),
            content: 'Must select at least a place?',
            okText: 'OK',
            onCancel: () => {
                console.log('Cancel');
            },
            onOk: () => {
                console.log('click ok button');
            }
        });
    };

    const clearAllRequestCondition = () => {
        dispatch(updateFirstTabValues({
            selectedPropertySet: [],
            currentRadius: 1,
            placeSelectSet: []
        }));
    };

    const handleExcuteButtonClick = () => {
        if (placeSelectSet && placeSelectSet.length === 0) {
            return placemWarning();
        }

        if (selectedPropertySet && selectedPropertySet.length === 0) {
            return propertymWarning();
        }
        excuteButtonClick();
    };

    return (
        <div className='tabs-container'>
            <SoilInputSelectComponent
                selectCallback={(select: string, option: ISoilProfilePlaceGeoNames) => {
                    const newSet = [...placeSelectSet];
                    newSet.push(option);
                    dispatch(updateFirstTabValues({
                        placeSelectSet: newSet
                    }));
                }}
                selectedPlaceCount={placeSelectSet.length}
            />
            <div className='add-selected-place-div'>
                {placeSelectSet.map((item, index) => {
                    return (
                        <span
                            className='add-selected-place-tag'
                            key={`${item.countryCode}-${item.geonameId}-${index}`}
                        >
                            {`${item.name},${item.adminName1}`}
                            <button onClick={() => handleDeleteItemTag(index)}>
                                <SoilSearchClearIcon className='close-icon-style' />
                            </button>
                        </span>
                    );
                })}
            </div>
            <div className='location-neighbor-area-div'>
                <p>Neighbor Soil Analysis location in radius, km</p>
                <div className='slider-super-div'>
                    <Slider
                        className='slider-own'
                        min={1}
                        max={radiusSetting.maxValue}
                        defaultValue={1}
                        onChange={(value)=> dispatch(updateFirstTabValues({currentRadius: value}))}
                        value={currentRadius}
                    />
                    <div className='radius-value-div'>
                        {currentRadius}
                    </div>
                </div>
                <p>Locations in this radius will be included</p>
            </div>
            <h4>Soil Properties</h4>
            <SoilSearchProperties
                dataSource={soilPropertyList}
                selectedText={selectedProperty && selectedProperty.name}
                selectTargetPropertiesCallback={(record) => handlePropertyListSelect(record)}
                propertiesDivClick={() => propertiesDivClick()}
            />
            <div className='soil-properties-tag'>
                <div className='inner-div'>
                    {selectedPropertySet.map((item) => (
                        <div className='property-tag' key={item.id}>
                            <span className={item.category === 'Chemical' ?
                                'chemical-categoty-span' : 'physical-category-span'}>
                                {item.category}
                            </span>
                            {item.name}
                            <button onClick={() => handleRemoveProperty(item)}>
                                <SoilSearchClearIcon className='close-icon-style' />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            <div className='bottom-button-div'>
                <button className='clear-button' onClick={clearAllRequestCondition}>
                    Clear
                </button>
                <div>
                    <button
                        className='clear-button'
                        onClick={saveQueryButtonClick}
                    >
                        Save Query
                    </button>
                    <button
                        onClick={() => handleExcuteButtonClick()}
                        className='fill-soil-properties'>
                        {placeSelectSet.length > 0 ? (selectedPropertySet.length > 0 ? 'Execute' : 'Fill soil properties') : 'Fill location'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FirstTabComponent;